const selectors = (state: any) => ({
	//state selectors
	firstName: state.firstName,
	lastName: state.lastName,
	email: state.email,
	address: state.homeAddress,
	salesPrice: state.salesPrice,
	loanPayoffs: state.loanPayoffs,
	reconveyanceFee: state.reconveyanceFee,
	realEstateCommissionPercent: state.realEstateCommissionPercent,
	realEstateCommission: state.realEstateCommission,
	titleInsurance: state.titleInsurance,
	escrowFee: state.escrowFee,
	sellersContributions: state.sellersContributions,
	other1Label: state.other1Label,
	other1: state.other1,
	other2Label: state.other2Label,
	other2: state.other2,
	records: state.tableReference,
	estimatedNetProceeds: state.estimatedNetProceeds,
	estimatedTotalCosts: state.estimatedTotalCosts,
	modalVisibility: state.modalVisibility,
	modalMessage: state.modalMessage,
	loader: state.loader,

	//action selectors
	setRealEstateCommissionPercent: state.setRealEstateCommissionPercent,
	setRealEstateCommission: state.setRealEstateCommission,
	setReconvayanceFee: state.setReconvayanceFee,
	setLoanPayoffs: state.setLoanPayoffs,
	setEscrowFee: state.setEscrowFee,
	setEstimatedTotalCosts: state.setEstimatedTotalCosts,
	setEstimatedNetProceeds: state.setEstimatedNetProceeds,
	setSalesPrice: state.setSalesPrice,
	setLoader: state.setLoader,
	setModalMessage: state.setModalMessage,
	setModalVisibility: state.setModalVisibility
});

export default selectors;
